import { render, staticRenderFns } from "./PartnerOrderRequests.vue?vue&type=template&id=48914bc0&scoped=true"
import script from "./PartnerOrderRequests.vue?vue&type=script&lang=js"
export * from "./PartnerOrderRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48914bc0",
  null
  
)

export default component.exports